// Casa de CBD - Theme JavaScript

// =====================
// 1. CART COUNT UPDATE
// =====================
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var countElement = document.getElementById('cart-count');
      if (countElement) {
        countElement.textContent = cart.item_count;
        if (cart.item_count > 0) {
          countElement.style.display = 'flex';
        } else {
          countElement.style.display = 'none';
        }
      }
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// =====================
// 2. FORM SUBMIT (ULTIMATE FIX FOR DUPLICATES)
// =====================
document.addEventListener('submit', function(e) {
  // Provjera je li ovo forma za košaricu (pokriva sve jezike /hr/, /cs/, /de/)
  if (e.target.action && e.target.action.includes('/cart/add')) {
    
    // 1. ODMAH ZAUSTAVI SVE
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const form = e.target;

    // 2. Spriječi dvostruki klik (debounce)
    if (form.getAttribute('data-submitting') === 'true') return false;
    form.setAttribute('data-submitting', 'true');

    const formData = new FormData(form);

    // 3. Uzmi URL iz forme i osiguraj .js nastavak
    let actionUrl = form.getAttribute('action');
    if (!actionUrl.includes('.js')) {
        // Ako URL već ima query parametre (?), umetni .js prije njih
        if (actionUrl.includes('?')) {
            actionUrl = actionUrl.replace('?', '.js?');
        } else {
            actionUrl += '.js';
        }
    }

    // 4. Šalji samo JEDAN zahtjev
    fetch(actionUrl, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest' // Govori Shopifyju da je ovo AJAX
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Network error');
      return response.json();
    })
    .then(data => {
      updateCartCount();
      showCartMessage('Product added to cart!');
    })
    .catch(error => {
      console.error('Cart error:', error);
    })
    .finally(() => {
      // Otključaj formu nakon 1 sekunde (sigurnosni razmak)
      setTimeout(() => {
        form.setAttribute('data-submitting', 'false');
      }, 1000);
    });

    return false; // Dodatna zaštita za stare browsere
  }
}, true); // <--- BITNO: 'true' ovdje znači "Capture phase" (hvata event prije svih ostalih)

// =====================
// 3. SUCCESS MESSAGE
// =====================
function showCartMessage(text) {
  const message = document.createElement('div');
  message.style.cssText = 'position: fixed; top: 20px; right: 20px; background: var(--color-primary); color: #000; padding: 1rem 1.5rem; border-radius: 0.5rem; font-weight: 600; z-index: 9999; animation: slideIn 0.3s ease;';
  message.textContent = text;
  document.body.appendChild(message);

  setTimeout(() => {
    message.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => message.remove(), 300);
  }, 2000);
}

// =====================
// 4. MOBILE MENU
// =====================
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuButton = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // Osvježi broj u košarici pri učitavanju stranice
  updateCartCount();
});

// =====================
// 5. CSS ANIMACIJE
// =====================
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
  }
  @keyframes slideOut {
    from { transform: translateX(0);    opacity: 1; }
    to   { transform: translateX(100%); opacity: 0; }
  }
`;
document.head.appendChild(style);
